export default __webpack_public_path__ + "static/media/logo-label-rse.2a3c501b.png";